module.exports = __webpack_public_path__ + "assets/static/media/splash_screen_3.df830163.png";